// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2rgB2","list":"BalanceDue_list__2UGvo","listRow":"BalanceDue_listRow__2P50P","total":"BalanceDue_total__1RnTT"};